import { render, staticRenderFns } from "./MasterAppDrawer.vue?vue&type=template&id=bb09d114&scoped=true&"
import script from "./MasterAppDrawer.vue?vue&type=script&lang=js&"
export * from "./MasterAppDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MasterAppDrawer.vue?vue&type=style&index=0&id=bb09d114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb09d114",
  null
  
)

export default component.exports